// extracted by mini-css-extract-plugin
module.exports = {"priceText":"CreatorsTable_priceText__iU7fb","brand06Text":"CreatorsTable_brand06Text__fdejq","avatarArea":"CreatorsTable_avatarArea__kwDsz"};